import React, { Fragment } from "react";
import Layout from "../components/Layout"
import Img from 'gatsby-image';
import { List, Button, Card, Divider, Image, Placeholder, Icon, Header} from 'semantic-ui-react';
import styled from "@emotion/styled";
import { spacing } from "../util/styles";
import { loadStripe } from "@stripe/stripe-js";
import Firebase from "../services/firebase";

export const StyledImage = styled(Img)`
  margin-right: ${spacing.lg}px;
  display: block;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
`;

export class CartPage extends React.Component {


  constructor(props) {
    super(props);

    this.state = {
      products: {"products":[]},
      sum:0,
      isLoading:false

    };
    this.purchaseProduct = this.purchaseProduct.bind(this);
    this.removeCartItem = this.removeCartItem.bind(this);
    this.render = this.render.bind(this);


    this.state.products = window.localStorage.getItem("products")? JSON.parse(window.localStorage.getItem("products")): {"products":[]};
    this.state.products.products.forEach(product=>{
      this.state.sum = product.price + parseInt(this.state.sum);

    });

    for(let i = 0; i<this.state.products.products.length; i++){
      this.state.products.products[i].uuid = i;
    }

  }


  purchaseProduct =  async () => {
    this.setState(() => ({ isLoading: true }));
    const stripe = await loadStripe('pk_test_a5EVbwuFXfYZf7vfxX6a9sHI00aMrDjDlB');
    let skus = [];
    this.state.products.products.forEach(product=>{
      skus.push(product.sku)
    });



    var callUserProfile = Firebase.functions().httpsCallable('stripeCheckout');
    const profileUpdate = {
      price: skus,
      quantity: 1,
      mode: "payment"
    };
    callUserProfile(profileUpdate)
      .then(function(result) {
        // Read result of the Cloud Function.
        stripe.redirectToCheckout({
          // Make the id field from the Checkout Session creation API response
          // available to this file, so you can provide it as parameter here
          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
          sessionId: result.data.checkoutSessionId
        }).then()
          .catch((e) => {
            console.error(e);
          })
      });
  };

  removeCartItem = (uuid) => {
    let products = this.state.products.products;

    for(let i = 0; i<products.length;i++){
          if(uuid === products[i].uuid ){
              products.splice(i,1);
              break;
          }
    }

    this.setState(() => ({ products:{"products":products}}));
    window.localStorage.setItem("products", JSON.stringify({"products":products}));
    let sum = 0;
this.setState({ sum: 0 });

    products.forEach(product=>{
      sum = product.price + sum;
    });

    this.setState(() => ({ "sum": sum }));

  };

  render(){
  return (
    <div>
      <Divider horizontal>
        <Button
          color='teal'
          onClick={this.purchaseProduct}
          content='Checkout'
          textAlign="center"
          fluid
          size='large'
          loading={this.state.isLoading}
          icon='cart'
          label={{ basic: true, color: 'teal', pointing: 'left', content: "$"+this.state.sum, size:'large'}}
        />
      </Divider>
      <br/>
      <Card.Group doubling itemsPerRow={5} stackable>

        {
          this.state.products.products.map((product) => (

            <Card key={product.uuid}>
              {
                // TODO: How to show a CMS image?
                typeof image === 'string' ?
                  <img src={product.image.childImageSharp.fluid.src}
                       alt={'product'} />
                  :
                  <StyledImage
                    fluid={product.image.childImageSharp.fluid} />
              }
              <Card.Content>
                <Fragment>
                  <Card.Header>{product.name}</Card.Header>
                  <Card.Meta>{product.sku}</Card.Meta>
                  <Card.Description>${product.price}</Card.Description>
                </Fragment>
              </Card.Content>
              <Card.Content extra>
                <Button onClick={() => this.removeCartItem(product.uuid)}>Remove</Button>
              </Card.Content>
            </Card>
          ))}
      </Card.Group>
      <Divider horizontal>
        <Header as='h1'>
          <Icon name='money bill alternate' />
          Free Shipping On Orders Over $50
        </Header>
      </Divider>

    </div>
  );
}

};
